import React from "react";
import { Helmet } from "react-helmet";


class PGP extends React.Component
{
    constructor(props)
    {
        super(props);
    }
    componentDidMount()
    {
        // Highlight JS
        console.log("Reloading Highlight JS")
        const script_highlight = document.createElement("script");
        script_highlight.text = "hljs.highlightAll();";
        script_highlight.async = true;
        document.body.appendChild(script_highlight);
    }
    render()
    {
        return (
            <div>
                <Helmet>
                    <title>PGP | Lucas RODRIGUEZ</title>
                </Helmet>
                <h2>PGP key</h2>
                <p>
                    Please use the below key to <b>strengthen the exchange security</b> of your sensitive content.
                </p>
                <a className="btn btn-outline-primary" href="keys/Lucas_RODRIGUEZ.asc" download={"Lucas_RODRIGUEZ.asc"} style={{ "margin": "20px" }} target={"_BLANK"}>Download PGP key</a>
                <ul>
                    <li>PGP Key ID <pre><code className="language-plaintext">3D45BF9246C01109</code></pre></li>
                    <li>PGP Fingerprint <pre style={{ "display": "inline" }}><code className="language-plaintext">4D53 048F 4AB0 6AB1 99CE  3A79 3D45 BF92 46C0 1109</code></pre></li>
                </ul>
                <p className="text-muted small">The key is also available on a <a href="https://github.com/lcsrodriguez/pgp-keys" target={"_BLANK"}>dedicated Git repository</a>.</p>
            </div>
        );
    }
}
export default PGP;